'use client';

import clsx from 'clsx';

export const SwabKitProductDetailsDescription: React.FC = () => {
  return (
    <>
      {/* <div className="text-lg leading-[27px] tracking-[-0.54px] mb-3">Description:</div> */}

      <div className={clsx('mb-8 hidden lg:block', 'responsive-text-15-16 font-light')}>
        Created by experts from Stanford University, the NBA, and Mayo Clinic. This is where the
        guesswork ends. Find out what your body needs through your DNA in the comfort of your own
        home.
      </div>
    </>
  );
};
